export default __webpack_public_path__ + "static/media/icono-nivelhospitalario.3392bf38.svg";